import axios from '../../axios';
import { toast } from 'react-toastify';
import {
   ADD_TRANSPORT,
   DELETE_TRANSPORT,
   GET_TRANSPORT,
   UPDATE_TRANSPORT,
   GET_ONE_TRANSPORT,
   MULTI_DELETE_TRANSPORT,
} from '../types';

export const getTransport = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/transport/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_TRANSPORT,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         return res.data;
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // console.error("Failed to get Transport. Please try again. :", err);
   }
};

export const addTransport = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/transport/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_TRANSPORT, payload: res.data.data });
         setTimeout(() => {
            toast.success('Transport added successfully!');
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updateTransport = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/transport/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_TRANSPORT, payload: res.data.data });

         setTimeout(() => {
            toast.success('Transport updated successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to update Transport. Please try again.");
   }
};

// Delete Transport
export const deleteTransport = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/transport/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_TRANSPORT, payload: { id } });
         setTimeout(() => {
            toast.success('Transport deleted successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to delete Transport. Please try again.");
   }
};

export const multiDeleteTransport = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/transport/delete/multi`, formData);

      if (res.data.code === 1) {
         dispatch({ type: MULTI_DELETE_TRANSPORT, payload: res.data.data });

         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

export const getSingleTeansport = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/transport/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_TRANSPORT, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
